<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">
        <tabulator
            :columns="columns"
            ajax-path="freeradius/accounts/online"
        />        
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Form from '@/helpers/Form';
    import debounce from 'lodash/debounce';
    import {secondsToDays} from '@/helpers/Formatter';

    export default {        
        data() {
            return {
                tableIsLoading: false,
                columns: [
                    {
                        title: 'Username',
                        field: 'username',
                        sorter: 'string',
                        minWidth: 300,
                    },
                    {
                        title: 'NAS Port ID',
                        field: 'nasportid',
                        sorter: 'string',
                        minWidth: 150,
                        visible: false,
                        download: true,
                    },
                    {
                        title: 'Account Start Time',
                        field: 'account_start_time_for_human',
                        sorter: 'string',
                        minWidth: 190,
                    },
                    {
                        title: 'Account Update Time',
                        field: 'account_update_time_for_human',
                        sorter: 'string',
                        minWidth: 190,
                    },
                    {
                        title: 'Account Interval',
                        field: 'acctinterval',
                        sorter: 'string',
                        minWidth: 170,
                        visible: false,
                        download: true,
                    },
                    {
                        title: 'Account Session Time',
                        field: 'acctsessiontime',
                        sorter: 'string',
                        minWidth: 160,
                        cssClass: 'text-right',
                        formatter({_cell}) {
                            return secondsToDays(_cell.value);
                        }
                    },
                    {
                        title: 'Upload',
                        field: 'upload_in_mb',
                        sorter: 'string',
                        minWidth: 110,
                        cssClass: 'text-right',
                        formatter({_cell}) {
                            return `${_cell.value} MB`
                        }
                    },
                    {
                        title: 'Download',
                        field: 'download_in_mb',
                        sorter: 'string',
                        minWidth: 110,
                        cssClass: 'text-right',
                        formatter({_cell}) {
                            return `${_cell.value} MB`
                        }
                    },
                    {
                        title: 'Framed IP Address',
                        field: 'framedipaddress',
                        sorter: 'string',
                        minWidth: 140,
                    }
                ],
            }
        },
        computed: {
            ...mapGetters({
                items: 'freeradius/accounts/items',
                item: 'freeradius/accounts/item',
            })
        },
    }
</script>